import * as firebase from "firebase";

export enum FileType {
  syllabus = 'syllabus',
  assignment = 'assignment',
  quiz = 'quiz',
  midterm = 'midterm',
  final = 'final'
}

export interface ICourseMaterial {
  fileType: FileType;
  fileName: string;
  downloadUrl?: string;

  year?: number;
  semester?: string;

  // hack
  // when we save to firestore we send FieldValue
  // when we get from firestore we get Timestamp
  createdAt: firebase.firestore.Timestamp | firebase.firestore.FieldValue;
}